import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex text-gray-800" }

import { toRefs } from 'vue';
import { useTenantStore } from '@/store';
import { EMIT } from '@/enum';

interface PropsInterface {
  id?: number;
  open: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'RestoreTenantConfirm',
  props: {
    id: {},
    open: { type: Boolean }
  },
  emits: [EMIT.CANCEL, EMIT.UPDATE],
  setup(__props: any, { emit: __emit }) {

const tenantStore = useTenantStore();

const emit = __emit;
const props = __props;
const { id, open } = toRefs(props);

const onCancel = () => emit(EMIT.CANCEL);

const onRestore = () => {
  if (id?.value) {
    tenantStore.restoreTenant(id.value);
    open.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(open))
      ? (_openBlock(), _createBlock(_component_ConfirmAction, {
          key: 0,
          header: "Restore Tenant",
          message: "Are you sure you want to Restore this tenant?",
          "accept-label": "Restore",
          onAccept: onRestore,
          onCancel: onCancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Icon, {
                name: "warning",
                class: "confirm-dialog-icon text-gray-600"
              }),
              _cache[0] || (_cache[0] = _createElementVNode("span", {
                class: "w-10 pl-3",
                textContent: `Are you sure you want to Restore this tenant?`
              }, null, -1))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})